import React from 'react'
import ToolsCard from './ToolsCard'
import ToolsImg01 from '../assets/media/skills/cs-01.png';
import ToolsImg02 from '../assets/media/skills/cs-02.png';
import ToolsImg03 from '../assets/media/skills/cs-03.png';
import ToolsImg04 from '../assets/media/skills/cs-04.png';
import ToolsImg05 from '../assets/media/skills/cs-05.png';
import ToolsImg06 from '../assets/media/skills/cs-06.png';
import ToolsImg07 from '../assets/media/skills/cs-07.png';
import ToolsImg08 from '../assets/media/skills/cs-08.png';
import ToolsImg09 from '../assets/media/skills/cs-09.png';
import ToolsImg10 from '../assets/media/skills/cs-10.png';
import ToolsImg11 from '../assets/media/skills/cs-11.png';
import ToolsImg12 from '../assets/media/skills/cs-12.png';
import ToolsImg13 from '../assets/media/skills/cs-13.png';
import ToolsImg14 from '../assets/media/skills/cs-14.png';
import ToolsImg15 from '../assets/media/skills/cs-15.svg';

function Tools() {
  return (
    <div className='tool-sec'>
      <ToolsCard title="HTML" img={ToolsImg01}/>
      <ToolsCard title="CSS" img={ToolsImg02}/>
      <ToolsCard title="JavaScript" img={ToolsImg03}/>
            <ToolsCard title="Bootstrap" img={ToolsImg04}/>
      <ToolsCard title="React" img={ToolsImg05}/>
      <ToolsCard title="Node Js" img={ToolsImg06}/>
      <ToolsCard title="Mongo Db" img={ToolsImg07}/>
      <ToolsCard title="Express Js" img={ToolsImg08}/>
      <ToolsCard title="Postman" img={ToolsImg09}/>
      <ToolsCard title="Git" img={ToolsImg10}/>
      <ToolsCard title="Vs Code" img={ToolsImg11}/>
      <ToolsCard title="Figma" img={ToolsImg12}/>
      <ToolsCard title="Canva" img={ToolsImg13}/>
    <ToolsCard title="React Bits" img={ToolsImg14}/> 
       <ToolsCard title="Rive" img={ToolsImg15}/>
      
    </div>
  )
}

export default Tools
